// @ts-ignore
import html2pdf from 'html2pdf.js';

export interface PdfOptions {
  margin?: number | number[];
  filename?: string;
  image?: { type: string; quality: number };
  html2canvas?: {
    scale: number;
    useCORS: boolean;
    letterRendering: boolean;
  };
  jsPDF?: {
    unit: string;
    format: string;
    orientation: string;
  };
  pagebreak?: {
    mode: string[];
    before?: string[];
    after?: string[];
    avoid?: string[];
  };
}

export class PdfExportService {
  private static defaultOptions: PdfOptions = {
    margin: [10, 10, 10, 10],
    filename: 'document.pdf',
    image: {type: 'jpeg', quality: 0.98},
    html2canvas: {
      scale: 2,
      useCORS: true,
      letterRendering: true
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait'
    },
    pagebreak: {
      mode: ['avoid-all', 'css', 'legacy'],
      before: ['.page-break-before'],
      after: ['.page-break-after'],
      avoid: ['.no-page-break']
    }
  };

  static async exportToPdf(
      element: HTMLElement,
      options: Partial<PdfOptions> = {}
  ): Promise<void> {
    try {
      // Clone the html source
      const clone = element.cloneNode(true) as HTMLElement
      // Wait for rendering
      await new Promise(resolve => setTimeout(resolve, 100));

      // Update cloned content before print
      this.preparePdfElement(clone)

      const finalOptions = {...this.defaultOptions, ...options};
      const pdf = html2pdf()
          .set(finalOptions)
          .from(clone);
      await pdf.save();
    } catch (error) {
      console.error('PDF export failed:', error);
      throw new Error(`Failed to export PDF: ${error}`);
    }
  }

  private static preparePdfElement(element: HTMLElement): void {
    // Hide browser-only elements
    const browserElements = element.querySelectorAll('[hide-in-pdf]');
    browserElements.forEach(el => {
      (el as HTMLElement).style.display = 'none'
    })

    // Show PDF-only elements
    const pdfElements = element.querySelectorAll('[only-display-in-pdf]')
    pdfElements.forEach(el => {
      (el as HTMLElement).style.display = 'block'
    })
  }

}
